import BigNumber from "bignumber.js";

/* eslint-disable no-useless-escape */
export default class CIUtils {

  
  static stockid(id: number) {
    const n: string = id + "";
    return n.length >= 6 ? n : new Array(6 - n.length + 1).join("0") + n;
  }

  static stockidFromResult(result: any) {
    if (!result) return result;

    result.map((item: any) => {
      this.stockid(item.id);
      return result;
    });

    return result;
  }

  static validateEmail = (email) => {
    const regex =
      /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
    return regex.test(email);
  };

  static removeWhitespace = (text) => {
    const regex = /\s/g;
    return text.replace(regex, "");
  };

  static padId(id: number) {
    const n: string = id + "";
    return (
      "43" + (n.length >= 6 ? n : new Array(6 - n.length + 1).join("0") + n)
    );
  }
}

export const getPercentageFromPrice = (
  price: number,
  min: number,
  max: number
) => {
  return Math.ceil(((price - min) / (max - min)) * 100);
};

export const padDP = (number: number, dp: number) => {
  try {
    if (!dp) dp = 1;
    const n = new BigNumber(number);
    return n.toFormat(dp);
  } catch (e) {
    console.error(e);
    return number.toFixed(dp);
  }
};

export const toShortNumber = (value: string | number) => {
  const number = new BigNumber(value);
  let shortNumber: any = number;

  if (number.isGreaterThanOrEqualTo(1e12)) {
    shortNumber = number.dividedBy(1e12).decimalPlaces(2, BigNumber.ROUND_DOWN).toString() + 'T';
  } else if (number.isGreaterThanOrEqualTo(1e9)) {
    shortNumber = number.dividedBy(1e9).decimalPlaces(2, BigNumber.ROUND_DOWN).toString() + 'B';
  } else if (number.isGreaterThanOrEqualTo(1e6)) {
    shortNumber = number.dividedBy(1e6).decimalPlaces(2, BigNumber.ROUND_DOWN).toString() + 'M';
  } else if (number.isGreaterThanOrEqualTo(1e3)) {
    shortNumber = number.dividedBy(1e3).decimalPlaces(2, BigNumber.ROUND_DOWN).toString() + 'K';
  } else {
    shortNumber = number.decimalPlaces(3, BigNumber.ROUND_DOWN).toFormat(); // 3자리 이하
  }

  return shortNumber?.toString() === 'NaN' ? '-' : shortNumber?.toString();
};

export const maskNumber = (number: number | string, isMask: boolean) => {
  if (isMask) return number;

  // 숫자를 문자열로 변환
  const strNumber = number?.toString();

  // 문자열의 첫 번째 숫자와 마지막 숫자를 제외하고, 나머지 숫자를 "*"로 대체
  const maskedNumber =
    "*".repeat(strNumber?.length - 1) +
    strNumber?.substring(strNumber?.length - 1);

  return maskedNumber;
};

export async function copyTextToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
  } else {
    // Use the 'out of viewport hidden text area' trick
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Move textarea out of the viewport so it's not visible
    // textArea.style.position = "absolute";
    // textArea.style.left = "-999999px";

    textArea.setAttribute("readonly", "true");
    textArea.style.position = "fixed"; // iOS에서 화면 이동 방지
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.width = "1px";
    textArea.style.height = "1px";
    textArea.style.opacity = "0";


    document.body.appendChild(textArea);
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length); // iOS 대응

    try {
      document.execCommand("copy");
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        document.body.removeChild(textArea);
      }, 100); // DOM 제거를 지연하여 안정성 향상
    }
  }
}

export const isIos = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};


// 청산가 계산
export function calculateLiquidPrice(coin: string, price: number, amount: number, margin: number, long_short: string, cross_iso: string, balance: number, leverage: number) {
  try {
    const size = new BigNumber(amount).multipliedBy(leverage).toNumber();
    const WB = new BigNumber(cross_iso === 'C' ? balance : margin).toNumber();
    const value = new BigNumber(price).multipliedBy(size).toNumber();

    console.log(coin, price, amount, margin, long_short, cross_iso, balance, leverage, size, WB, value);

    let MA = 0;
    let MMR = 0.005;

    //BTC 
    if (coin === 'BTC') {
      if (value < 50000) {
        // 50,000 이하 기본값
        MA = 0
        MMR = 0.004  // 0.40%
      } else if (value < 250000) {
        // 50,000 ~ 250,000
        MA = 50
        MMR = 0.005  // 0.50%
      } else if (value < 3000000) {
        // 250,000 ~ 3,000,000
        MA = 1300
        MMR = 0.01   // 1.00%
      } else if (value < 20000000) {
        // 3,000,000 ~ 20,000,000
        MA = 46300
        MMR = 0.025  // 2.50%
      } else {
        // 20,000,000 초과
        MA = 546300
        MMR = 0.05   // 5.00% - 가장 높은 비율
      }
    } else if (coin === 'ETH') {
      if (value < 100000) {
        // 100,000 이하 기본값
        MA = 0
        MMR = 0.005  // 0.50%
      } else if (value < 250000) {
        // 100,000 ~ 250,000
        MA = 150
        MMR = 0.0065 // 0.65%
      } else if (value < 20000000) {
        // 250,000 ~ 20,000,000
        MA = 1025
        MMR = 0.01   // 1.00%
      } else if (value < 150000000) {
        // 20,000,000 ~ 150,000,000
        MA = 21025
        MMR = 0.02   // 2.00%
      } else if (value < 30000000) {
        // 150,000,000 ~ 30,000,000
        MA = 471025
        MMR = 0.05   // 5.00%
      } else {
        // 30,000,000 초과
        MA = 1971025
        MMR = 0.1    // 10.00% - 가장 높은 비율
      }
    } else if (coin === 'XRP') {
      if (value < 5000) {
        // 5,000 이하 기본값
        MA = 0
        MMR = 0.005  // 0.50% - 가장 낮은 비율
      } else if (value < 10000) {
        // 5,000 ~ 10,000
        MA = 0
        MMR = 0.006  // 0.60%
      } else if (value < 50000) {
        // 10,000 ~ 50,000
        MA = 0
        MMR = 0.01   // 1.00%
      } else if (value < 250000) {
        // 50,000 ~ 250,000
        MA = 0
        MMR = 0.02   // 2.00%
      } else if (value < 1000000) {
        // 250,000 ~ 1,000,000
        MA = 0
        MMR = 0.05   // 5.00%
      } else {
        // 1,000,000 초과
        MA = 0
        MMR = 0.1    // 10.00% - 가장 높은 비율
      }
    } else if (coin === 'BCH') {
      if (value < 5000) {
        // 5,000 이하 기본값
        MA = 0
        MMR = 0.005  // 0.50%
      } else if (value < 10000) {
        // 5,000 ~ 10,000
        MA = 7.5
        MMR = 0.0065 // 0.65%
      } else if (value < 50000) {
        // 10,000 ~ 50,000
        MA = 42.5
        MMR = 0.01   // 1.00%
      } else if (value < 500000) {
        // 50,000 ~ 500,000
        MA = 542.5
        MMR = 0.02   // 2.00%
      } else if (value < 2000000) {
        // 500,000 ~ 2,000,000
        MA = 15542.5
        MMR = 0.05   // 5.00%
      } else {
        // 2,000,000 초과
        MA = 115542.5
        MMR = 0.1    // 10.00% - 가장 높은 비율
      }
    } else if (coin === 'LTC') {
      if (value < 5000) {
        // 5,000 이하 기본값
        MA = 0
        MMR = 0.005  // 0.50%
      } else if (value < 10000) {
        // 5,000 ~ 10,000
        MA = 5
        MMR = 0.006  // 0.60%
      } else if (value < 50000) {
        // 10,000 ~ 50,000
        MA = 45
        MMR = 0.01   // 1.00%
      } else if (value < 750000) {
        // 50,000 ~ 750,000
        MA = 545
        MMR = 0.02   // 2.00%
      } else if (value < 3000000) {
        // 750,000 ~ 3,000,000
        MA = 23045
        MMR = 0.05   // 5.00%
      } else {
        // 3,000,000 초과
        MA = 173045
        MMR = 0.1    // 10.00% - 가장 높은 비율
      }
    } else if (coin === 'EOS') {
      if (value < 5000) {
        // 5,000 이하 기본값
        MA = 0
        MMR = 0.005  // 0.50%
      } else if (value < 10000) {
        // 5,000 ~ 10,000
        MA = 5
        MMR = 0.006  // 0.60%
      } else if (value < 50000) {
        // 10,000 ~ 50,000
        MA = 45
        MMR = 0.01   // 1.00%
      } else if (value < 250000) {
        // 50,000 ~ 250,000
        MA = 545
        MMR = 0.02   // 2.00%
      } else if (value < 1000000) {
        // 250,000 ~ 1,000,000
        MA = 8045
        MMR = 0.05   // 5.00%
      } else {
        // 1,000,000 초과
        MA = 58045
        MMR = 0.1    // 10.00% - 가장 높은 비율
      }
    } else if (coin === 'XMR') {
      if (value < 50000) {
        // 50,000 이하 기본값
        MA = 0
        MMR = 0.01   // 1.00%
      } else if (value < 250000) {
        // 50,000 ~ 250,000
        MA = 750
        MMR = 0.025  // 2.50%
      } else if (value < 1000000) {
        // 250,000 ~ 1,000,000
        MA = 7000
        MMR = 0.05   // 5.00%
      } else {
        // 1,000,000 초과
        MA = 57000
        MMR = 0.1    // 10.00% - 가장 높은 비율
      }
    }

    const A = WB + MA - (long_short == 'L' ? 1 : -1) * size * price;
    const B = size * MMR - (long_short == 'L' ? 1 : -1) * size;

    let liquid_price = new BigNumber(A).dividedBy(B).toNumber();

    console.log('@@@LIQUID', coin, value, size, price, `MA:${MA} MMR:${MMR} A:${A} B:${B} liquid_price:${liquid_price}`)

    if (liquid_price < 0) {
      liquid_price = 0
    } else if (liquid_price > 99999999) {
      liquid_price = 0
    } else if (isNaN(liquid_price)) {
      liquid_price = 0
    }

    return liquid_price;
  } catch (e) {
    console.log('@@@LIQUID', e)
    return 0;
  }
}

import API from "@/utils/api";
import { API_COIN_TIER } from "@/app/constants/APIKEYS";

// 코인별 tier 정보 인터페이스 (API 응답과 맞춤)
interface CoinTier {
  base: string;
  tier: number;
  notional_min: number;
  notional_max: number;
  mmr: number; // 유지증거금률
  ma: number;  // Maintenance Amount
  max_leverage: number;
}

// 티어 정보 캐시
const tierCache: Map<string, CoinTier[]> = new Map();
let lastFetchTime = 0;
const CACHE_DURATION = 10 * 60 * 1000; // 10분

// 티어 정보를 API로부터 가져오는 함수
async function fetchCoinTiers(): Promise<CoinTier[]> {
  try {
    const now = Date.now();
    
    // 캐시가 유효한 경우 캐시된 데이터 사용
    if (now - lastFetchTime < CACHE_DURATION && tierCache.size > 0) {
      return Array.from(tierCache.values()).flat();
    }
    
    const response = await API.send('GET', '/exchange/tier', null, {}, false, API_COIN_TIER);
    const tiers = response?.data?.tiers || [];
    
    // 코인별로 캐시 업데이트
    tierCache.clear();
    tiers.forEach((tier: CoinTier) => {
      if (!tierCache.has(tier.base)) {
        tierCache.set(tier.base, []);
      }
      tierCache.get(tier.base)!.push(tier);
    });
    
    lastFetchTime = now;
    return tiers;
  } catch (error) {
    console.error('Failed to fetch coin tiers:', error);
    
    // API 실패시 기본값 반환
    return [{
      base: 'BTC',
      tier: 1,
      notional_min: 0,
      notional_max: Infinity,
      mmr: 0.005,
      ma: 0,
      max_leverage: 100
    }];
  }
}

// 코인과 명목가에 맞는 티어 찾기
async function findTierByBaseAndNotional(coin: string, positionValue: number): Promise<CoinTier> {
  try {
    await fetchCoinTiers(); // 티어 정보 로드/캐시 확인
    
    const coinTiers = tierCache.get(coin) || [];
    
    if (coinTiers.length === 0) {
      console.warn(`No tier found for coin: ${coin}, using default`);
      return {
        base: coin,
        tier: 1,
        notional_min: 0,
        notional_max: Infinity,
        mmr: 0.005,
        ma: 0,
        max_leverage: 100
      };
    }
    
    // 명목가에 맞는 티어 찾기
    const matchingTier = coinTiers.find(tier => 
      positionValue >= tier.notional_min && positionValue < tier.notional_max
    );
    
    return matchingTier || coinTiers[coinTiers.length - 1]; // 마지막 tier 반환
  } catch (error) {
    console.error('Error finding tier:', error);
    return {
      base: coin,
      tier: 1,
      notional_min: 0,
      notional_max: Infinity,
      mmr: 0.005,
      ma: 0,
      max_leverage: 100
    };
  }
}

// 백엔드와 동일한 새로운 청산가 계산 함수
export async function calculateLiquidPriceNew(
  coin: string,
  price: number,
  amount: number,
  margin: number,
  long_short: string,
  cross_iso: string,
  balance: number,
  leverage: number,
  positions?: any[] // 다른 포지션 정보 (옵션)
) {
  try {
    console.log('@@@LIQUID INPUT', {
      coin,
      price,
      amount,
      margin,
      long_short,
      cross_iso,
      balance,
      leverage,
    });

    amount = amount * leverage; // amount는 코인 수량이 아니라 계약 수량입니다. 따라서 레버리지를 곱해줍니다.

    // 1. WB: 교차/격리 구분
    // 교차의 WB는 -> 전체 자산에서 격리마진의 총 증거금(margin) 뺀 값이 WB
    // DB에 margin 자체에 leverage가 적용되어 저장되어 있습니다. 그래서 다시 나눠야 합니다.
    const WB = new BigNumber(
      cross_iso === 'C' ? balance : BigNumber(margin).toNumber()
    );

    // tmm1과 upnl1 계산 (프론트엔드에서는 간소화)
    let tmm1 = 0;
    let upnl1 = 0;
    
    // 교차 마진 모드에서는 다른 포지션들의 영향을 고려해야 하지만,
    // 프론트엔드에서는 복잡하므로 기본값 0 사용
    if (cross_iso === 'C' && positions && positions.length > 0) {
      // 간단한 근사치 계산 (실제로는 백엔드 API 호출이 필요)
      // 여기서는 기본값 사용
      tmm1 = 0;
      upnl1 = 0;
    }

    // 2. tier 정보
    const positionValue = new BigNumber(price).multipliedBy(amount).toNumber();
    const tier = await findTierByBaseAndNotional(coin, positionValue);
    const MMR = new BigNumber(tier.mmr).toNumber(); // 유지증거금률
    const cumB = tier.ma; // Maintenance Amount

    // 3. 포지션 방향
    const side = long_short === 'L' ? 1 : -1;

    // 4. 공식 적용
    // 청산 가격 = WB - TMM1 + UPNL1 + cumB - ( Side1BOTH * Position1BOTH * EP1BOTH ) / ( Position1BOTH * MMR ) - ( Side1BOTH * Position1BOTH )

    // 격리 마진 모드 일때는 tmm1, upnl1 = 0
    if (cross_iso === 'I') {
      tmm1 = 0;
      upnl1 = 0;
    }

    console.log(
      '공식 대입하기전 :',
      'WB',
      WB.toNumber(),
      'tmm1 :',
      tmm1,
      'upnl1 :',
      upnl1,
      'cumB : ',
      cumB,
      'side : ',
      side,
      'price : ',
      price,
      'positionValue : ',
      positionValue,
      'MMR : ',
      MMR,
      'amount : ',
      amount
    );

    const liquidPrice = WB.minus(tmm1)
      .plus(upnl1)
      .plus(cumB)
      .minus(BigNumber(side).multipliedBy(positionValue))
      .dividedBy(
        BigNumber(amount)
          .multipliedBy(MMR)
          .minus(side * amount)
      );

    const liquidPriceNum = liquidPrice.toNumber();

    if (isNaN(liquidPriceNum)) {
      return 0;
    }

    return liquidPriceNum;
  } catch (e) {
    console.log('@@@LIQUID', e);
    return 0;
  }
}